const guestLimitAlertEnum = Object.freeze({
  ERROR_GUEST_AMOUNT_LIMIT_EXCEED: -73,
  ERROR_GUEST_QUANTITY_LIMIT_EXCEED: -74,
});

export default guestLimitAlertEnum;
